const env = process.env;

export default {
    contentApiBaseUrl: env.CONTENT_API_BASE_URL,
    googleMapsApiKey: env.GOOGLE_MAPS_API_KEY,
    applicationInsightsKey: env.APPLICATION_INSIGHTS_KEY
};



// WEBPACK FOOTER //
// ./src/config/index.js